import { createSelector } from '@ngrx/store';
import { selectEntities } from '../entities';
import { AnnouncementArchiveEntitiesState } from './announcement-archive-entities.state';

/**
 * Selectors für die Archiv-Seite.
 */
export class AnnouncementArchiveEntitiesSelectors {
  private static readonly _feature = createSelector(
    selectEntities,
    (state): AnnouncementArchiveEntitiesState => state.announcementArchiveEntities,
  );

  /** Alle Announcements der aktuellen Seite. */
  static readonly announcements = createSelector(
    this._feature,
    (state) => state.announcements,
  );

  /** Gesamtanzahl der Announcements (für Pagination). */
  static readonly totalElements = createSelector(
    this._feature,
    (state) => state.totalElements,
  );

  /** Aktuelle Seitennummer. */
  static readonly currentPage = createSelector(
    this._feature,
    (state) => state.currentPage,
  );

  /** Seitengröße. */
  static readonly pageSize = createSelector(
    this._feature,
    (state) => state.pageSize,
  );

  /** Ladezustand. */
  static readonly isLoading = createSelector(
    this._feature,
    (state) => state.isLoading,
  );

  /** Ob die Daten mindestens einmal geladen wurden. */
  static readonly isLoaded = createSelector(
    this._feature,
    (state) => state.isLoaded,
  );

  /** Fehlermeldung. */
  static readonly error = createSelector(
    this._feature,
    (state) => state.error,
  );

  /** Alle Blob-URLs als Record. */
  static readonly imageUrls = createSelector(
    this._feature,
    (state) => state.imageUrls,
  );

  /**
   * Blob-URL eines Bildes per imageId.
   * @param imageId - Die ID des Bildes
   */
  static imageUrl(imageId: string) {
    return createSelector(
      this._feature,
      (state) => state.imageUrls[imageId] ?? null,
    );
  }
}
